import React, { FC, useEffect, useState } from "react"
import { connect } from "react-redux"
import { RootState } from "../../../../store"
import adminTrackShareHolderColumns from "./columns/adminTrackShareHolderColumns"
import { fetchTrackCollaboratorData, selectCollaboratorData } from "../../../../actions/adminActions"
import { AdminTrackShareHolderTableProps, CollaboratorData } from "../../../../types"
import {
  COLLAB_INVITATION_TABLE_ROW_STATUS,
  errorFilledToastOptions,
  infoFilledToastOptions,
  successFilledToastOptions
} from "../../../../constants"
import TableNew from "../../../ui/table/TableNew"
import { KButton, KTitleSpan } from "kahuna-base-react-components"
import { collaboratorInvitation, users } from "../../../../apis"
import { toast } from "react-toastify"

const AdminTrackShareHolderTable: FC<AdminTrackShareHolderTableProps> = (props) => {
  const [loading, setLoading] = useState(true)
  const [loadingEmail, setLoadingEmail] = useState(false)
  const trackId = props.trackId

  const fetchData = async () => {
    setLoading(true)
    if (trackId) {
      await props.fetchTrackCollaboratorData(trackId)
    }
  }

  useEffect(() => {
    fetchData().then(() => setLoading(false))
  }, [trackId])

  const inactiveRowIndexes = props.trackShareData.reduce(
    (indexes: number[], rowData: CollaboratorData, index: number) => {
      if (Number(rowData?.status) !== Number(COLLAB_INVITATION_TABLE_ROW_STATUS.Active)) {
        indexes.push(index)
      }
      return indexes
    },
    []
  )

  const onCollaboratorSelectRow = (index: number) => {
    //TODO: There is a bug about editing collaborator data, so it is cancelled for now. For now only adding will be possible.
    //props.selectCollaboratorData(props.trackShareData[index])
  }

  const onClickAdd = () => {
    props.selectCollaboratorData(new CollaboratorData())
  }

  const onResendEmail = (invitationId: number) => {
    if (loadingEmail || !window.confirm("Are you sure? This action will re-send invitation email to user.")) {
      return
    }
    toast.info("Email preparing...", infoFilledToastOptions)
    setLoadingEmail(true)
    collaboratorInvitation(`/re_send_invitation/?id=${invitationId}`, "put")
      .then((resp) => {
        setLoadingEmail(false)
        if (resp.data.success) {
          toast.success("Successfully sent email", successFilledToastOptions)
        } else {
          toast.error("Error sending email", errorFilledToastOptions)
        }
      })
      .catch(() => {
        toast.error("Error sending email", errorFilledToastOptions)
        setLoadingEmail(false)
      })
  }

  const onDeleteInvitation = (invitationId: number) => {
    if (!window.confirm("Are you sure you want to delete?")) {
      return
    }
    collaboratorInvitation(`/delete_invitation/?id=${invitationId}`, "delete")
      .then((resp) => {
        if (resp.data.success) {
          fetchData().then(() => setLoading(false))
          toast.success("Successfully deleted invatation", successFilledToastOptions)
        } else {
          toast.error("Error deleting invatation", errorFilledToastOptions)
        }
      })
      .catch(() => toast.error("Error deleting invatation", errorFilledToastOptions))
  }

  const tableTitle = (
    <div className="py-3 px-3">
      {" "}
      <KTitleSpan text="Collaborators" color="#000" fontSize={24} lineHeight="32px" />
    </div>
  )

  const topRightElement = () => {
    return (
      <KButton
        dataTestId="add-collaborator-button"
        icon="/admin_icons/plus.svg"
        onClick={onClickAdd}
        background="#F7F7F7"
        hoverBackground="#F3F3F3"
        padding="14px"
        disabled={false}
        width="48px"
        height="48px"
      />
    )
  }

  return (
    <div className="catalog flex-grow">
      <div className="mt-[16px] mb-16">
        <TableNew
          title={tableTitle}
          minRowCount={1}
          limit={1}
          columns={adminTrackShareHolderColumns(onResendEmail, onDeleteInvitation)}
          data={props.trackShareData}
          count={props.trackShareData.length}
          rowHeightInPx={40}
          loading={loading}
          topRightElement={topRightElement()}
          inactiveRows={inactiveRowIndexes}
          onSelectRow={onCollaboratorSelectRow}
          overrideTableOverflow="auto"
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user,
    trackShareData: state.admin.trackShareData,
    selectedCollaboratorData: state.admin.selectedCollaboratorData
  }
}

export default connect(mapStateToProps, { fetchTrackCollaboratorData, selectCollaboratorData })(
  AdminTrackShareHolderTable
)
